import Styled from "styled-components";

export interface YouTubeIframeProps {
  $allowfullscreen: boolean;
}

export const Container = Styled.div`
  padding: 3.125rem 0px 6.25rem;
  overflow: hidden;
  position: relative;

  ${(props) => props.theme.breakpoints.up("medium")} {
    padding: 3.125rem 0 12.5rem;
  }
`;

export const Content = Styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 5.75rem;
  width: ${(props) => props.theme.width};
  max-width: calc(100% - 2.5rem);
  z-index: 1;
  margin: 0 auto;
  
  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: calc(100% - 3rem);
    gap: 7.625rem;
  }
  
  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: calc(100% - 10rem);
    gap: 5.75rem;
  }
`;

export const Message = Styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h1 {
    margin: 2rem 0;
  }

  ${(props) => props.theme.breakpoints.up("medium")} {
    h1 {
      margin: 2.5rem 0;
    }
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    h1 {
      margin: 3.75rem 0;
    }
  }
`;

export const Pitch = Styled.div`
  font-size: 1.624rem;
  line-height: 2rem;
  font-weight: 500;
  letter-spacing: -0.2px;
  text-align: center;

  ${(props) => props.theme.breakpoints.up("medium")} {
    font-size: 1.875rem;
    line-height: 2.375rem;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    width: 90%;
  }

  & > p {
    margin: 1rem 0;
  }

  & > p:first-child {
    margin-top: 0;
  }

  & > p:last-child {
    margin-bottom: 0;
  }
`;

export const IllustrationContainer = Styled.div`
  position: relative;
  overflow: hidden;
  width: 1440px;
  max-width: 100%;
  height: 0px;
  margin: 0px auto;
  padding-bottom: 100%;
  border-radius: 32px;
  box-shadow: rgba(68, 20, 187, 0.75) 0px -20px 200px;
  cursor: pointer;

  video {
    position: absolute;
    z-index: 1;
    left: 0px;
    width: 100%;
  }

  ${(props) => props.theme.breakpoints.up("medium")} {
    padding-bottom: 53%;
  }
`;

export const VideoContainer = Styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

export const VideoFrame = Styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const YoutubeIframe = Styled.iframe<YouTubeIframeProps>`
  overflow: hidden;
  border-radius: 32px;
  border: none;
  box-shadow: 0px -20px 200px rgba(68, 20, 187, 0.5);
`;

export const CloseButton = Styled.button`
  background-color: transparent;
  border: none;
  position: absolute;
  top: 20px !important;
  right: 20px !important;
  cursor: pointer;
`;

export const BackgroundGradient = Styled.div`
  background: radial-gradient(rgb(68, 20, 187), rgb(23, 9, 56) 50%, rgb(4, 4, 4), rgb(3, 3, 3));
  width: 100%;
  height: 75%;
  position: absolute;
  top: 0%;
  z-index: -1;
`;

export const BackgroundImage = Styled.img`
  width: 100%;
  position: absolute;
  top: 0px;
  z-index: -1;
`;
